/**
 * <TutorReleaseSlotsSkeleton> — la forme de « Ta semaine » pendant que la semaine charge : la
 * consigne, puis des journées de pilules de la hauteur d'un poussoir `sm`.
 */
import React from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { pushButtonBoxHeight } from "../../atoms/Buttons/Button/Button"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"

const HOUR_WIDTHS = [78, 78, 78]

export function TutorReleaseSlotsSkeleton() {
    return (
        <Stack gap="5">
            <Stack gap="1">
                <Skeleton textSize="text-md" />
                <Skeleton textSize="text-md" width="70%" />
            </Stack>
            {[0, 1, 2, 3].map((day) => (
                <Stack key={day} gap="2">
                    <Skeleton textSize="text-xs" width={64} />
                    <View style={styles.hours}>
                        {HOUR_WIDTHS.map((width, index) => (
                            // eslint-disable-next-line react/no-array-index-key
                            <Skeleton key={index} shape="block" width={width} height={pushButtonBoxHeight("sm")} />
                        ))}
                    </View>
                </Stack>
            ))}
        </Stack>
    )
}

const styles = StyleSheet.create((theme) => ({
    hours: { flexDirection: "row", flexWrap: "wrap", gap: theme.spacing["2"] },
}))
